import React from "react";
import Faq from "../Faq";

export default function FaqSection() {
    return (
        <section
            id="faq"
            className="bt-section"
            data-testid="section-faq"
            style={{ borderTop: "1px solid var(--bt-rule)" }}
        >
            <div className="bt-shell">
                <div
                    className="bt-promise-grid"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        gap: 32,
                        marginBottom: 32,
                    }}
                >
                    <aside style={{ paddingTop: 14 }}>
                        <p className="signal" style={{ marginBottom: 14 }}>
                            № 07
                        </p>
                        <p className="marginalia" style={{ margin: 0, color: "var(--bt-mute)" }}>
                            Common questions
                        </p>
                    </aside>
                    <div className="bt-read">
                        <h2 className="t-display" style={{ margin: 0, marginBottom: 8 }}>
                            Questions, answered plainly.
                        </h2>
                    </div>
                </div>

                <div className="bt-promise-grid" style={{ display: "grid", gap: 32 }}>
                    <div />
                    <div className="bt-read">
                        <Faq />
                    </div>
                </div>
            </div>
        </section>
    );
}
